// ##### 24-06-19 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import YearBuilder from '../../../Library/Images/YearBuilder.jsx';

const NotFound = () => {
  // ##### 24-06-17 Komarov: TODO: Взять перевод из Смарта
  return (
    <div data-component="NotFound">
      <h2>Not Found</h2>
      {/* ##### Komarov 2025-07-14 */}
      {/* <YearAnimation /> */}
      <YearBuilder />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default NotFound;
